import { FC, useMemo } from 'react';
import type { ChartBindingValue, CustomChartTablePayload } from '@/entities/dashboards';
import type { ChartAppearance } from '../chartElements';
import { toIndexedRows } from './chartTable';
import { ChartTableCard } from './ChartTableCard';

type Props = {
  /** Диаграмма, чьей таблице принадлежит личный вид: состав колонок, упорядочение и фильтры */
  chartId: string;
  title: string;
  payload: CustomChartTablePayload;
  /** Оформление диаграммы: окрашиваемые колонки, цвета их значений и правила раскраски по величине */
  appearance?: ChartAppearance;
  /** Высота диаграммы задана пользователем — таблица прокручивает строки внутри неё */
  hasFixedHeight?: boolean;
  /** Открытие диалога строки; не задано — строки к диалогам не ведут */
  onOpenConversation?: (conversationId: number, openInNewTab: boolean) => void;
  /** Выбор строки наполняет связанную диаграмму; задан — выбор заменяет переход к диалогу */
  onSelectElement?: (value: ChartBindingValue) => void;
};

/**
 * Таблица: колонки и строки выборки показаны как пришли ({@link ChartTableCard}).
 *
 * Выбранная строка опознаётся значением первой колонки: им же наполняется связанная диаграмма.
 */
export const TableChartView: FC<Props> = ({ payload, ...props }) => {
  const indexedRows = useMemo(
    () => toIndexedRows(payload.rows, payload.conversationIds),
    [payload.rows, payload.conversationIds],
  );

  return (
    <ChartTableCard
      {...props}
      columns={payload.columns}
      rows={indexedRows}
      selectionColumn={payload.columns[0]?.code}
    />
  );
};
